// English comments only — axios client for auth bootstrap (no global interceptors)

import axios from "axios";

export const authHttp = axios.create({
  withCredentials: true,
});
